// import {CurrencyPipe} from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
// import {IBatchCSVData} from '@module/batch/interfaces/batch-csv-data';
import { CsvExportService } from 'src/app/services/csv-export.service';
import { IBatchListItem } from '../../interfaces/batch-list-item';

import { CurrencyPipe } from '@angular/common';
import { IBatchListConfig } from '../../interfaces/batch-list-config';
import { BatchApiService } from '../../services/batch-api-service';

@Component({
  selector: 'batch-list-dialog',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  standalone: false,
})
export class BatchOrderList {
  public Item: IBatchListItem[];
  public title: string;
  public DataSource: MatTableDataSource<IBatchListItem>;
  public loading: boolean;
  public batchApi: BatchApiService;
  public id: string;

  protected columns = [
    {
      name: 'name',
      width: '*',
    },
    {
      name: 'item_count',
      width: '*',
    },
    {
      name: 'price',
      width: '*',
    },
    {
      name: 'order_status',
      width: '*',
    },
  ];
  public displayedColumns = ['name', 'item_count', 'price', 'order_status'];

  private fileName = 'batch-export';
  private headers = [
    'First Name',
    'Surname',
    'Account ID',
    'Title',
    'Total',
    'Event Date',
  ];

  constructor(
    protected Dialog: MatDialog,
    private cp: CurrencyPipe,
    @Inject(MAT_DIALOG_DATA) protected config: IBatchListConfig,
  ) {
    this.Item = config.Item;
    this.title = config.title;
    this.DataSource = new MatTableDataSource(config.Item);
    this.batchApi = config.batchApi;
    this.id = config.id;
  }

  public downloadCSV() {
    this.loading = true;

    this.batchApi
      .getBatchExport('finance-admin', {
        batchId: this.id,
      })
      .then((response: any) => {
        if (response.data?.length > 0) {
          const { fileName, headers } = this;

          const formattedRows = response.data.map((row) => {
            const { firstName, surname, accountId, title, total, displayDate } =
              row;

            const totalFloat = (Number(total) / 100).toFixed(2);
            const price = this.cp.transform(
              totalFloat,
              'GBP',
              'symbol-narrow',
              '1.2-2',
            );
            return [firstName, surname, accountId, title, price, displayDate];
          });

          CsvExportService.export(formattedRows, fileName, {
            showLabels: true,
            headers,
          });
        }
      })
      .finally(() => (this.loading = false));
  }
}
